import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./solid/ai.svg";
var AiSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  AiSolid_default as default
};
